import {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";

export const ReportS2 = () => {
    const {year, bullstat} = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    useEffect(() => {
        request.get(`${baseUrl()}/reports/s2/${year}/${bullstat}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, bullstat]);

    const handlePdf = () => {
        downloadPdf(`/reports/s2/${year}/${bullstat}?format=pdf`, `S2_${bullstat}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const c = data.company;
    const t = data.totals;
    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С2 — Справка по ползвател за всички землища</h5>
                    <div>{c.company_name}, Булстат: {c.bullstat}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
            </div>

            <div className="table-responsive">
                <table className="table table-sm table-bordered">
                    <thead className="tableHead">
                    <tr>
                        <th>Землище</th>
                        <th className="text-end">Деклар.</th>
                        <th className="text-end">Негодна</th>
                        <th className="text-end">Годна</th>
                        <th className="text-end">БП</th>
                        <th className="text-end">Пътища</th>
                        <th className="text-end">ДЗ</th>
                        <th className="text-end">Правно</th>
                        <th className="text-end">Изчерт.</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.rows.map((row, i) => (
                        <tr key={i}>
                            <td>{row.settlement_name}</td>
                            <td className="text-end">{row.declared_land.toFixed(2)}</td>
                            <td className="text-end">{row.unsuitable_land.toFixed(2)}</td>
                            <td className="text-end">{row.suitable_land.toFixed(2)}</td>
                            <td className="text-end">{row.white_spots.toFixed(2)}</td>
                            <td className="text-end">{row.roads.toFixed(2)}</td>
                            <td className="text-end">{row.deals_sum.toFixed(2)}</td>
                            <td className="text-end">{row.pravno.toFixed(2)}</td>
                            <td className="text-end">{row.drawings_sum.toFixed(2)}</td>
                        </tr>
                    ))}
                    </tbody>
                    <tfoot>
                    <tr className="fw-bold">
                        <td>ОБЩО</td>
                        <td className="text-end">{t.declared_land.toFixed(2)}</td>
                        <td className="text-end">{t.unsuitable_land.toFixed(2)}</td>
                        <td className="text-end">{t.suitable_land.toFixed(2)}</td>
                        <td className="text-end">{t.white_spots.toFixed(2)}</td>
                        <td className="text-end">{t.roads.toFixed(2)}</td>
                        <td className="text-end">{t.deals_sum.toFixed(2)}</td>
                        <td className="text-end">{t.pravno.toFixed(2)}</td>
                        <td className="text-end">{t.drawings_sum.toFixed(2)}</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};
